export default {
    common: {
        datepicker: {
            months: {
                july: 'Juli',
                september: 'September',
                april: 'April',
                march: 'März',
                may: 'Mai',
                february: 'Februar',
                june: 'Juni',
                january: 'Januar',
                november: 'November',
                october: 'Oktober',
                august: 'August',
                december: 'Dezember',
            },
            days: {
                tuesday: 'Di',
                thursday: 'Do',
                saturday: 'Sa',
                wednesday: 'Mi',
                monday: 'Mo',
                friday: 'Fr',
                sunday: 'So',
            },
        },
        label: {
            insured: 'Versichert',
            selected: 'Ausgewählt',
            noValue: 'Keine Angaben vorhanden',
            cancel: 'Abbrechen',
            bestseller: 'Bestseller',
            moreDetails: 'Details',
            next: 'Weiter',
            no: 'Nein',
            ok: 'Ok',
            choose: 'Auswählen',
            to: 'bis',
            notInsured: 'Nicht versichert',
            back: 'Zurück',
            save: 'Speichern',
            edit: 'Bearbeiten',
            yes: 'Ja',
        },
        unsavedData: {
            message: 'Sie haben ungespeicherte Daten auf dieser Seite. Wollen Sie wirklich die Seite neu laden?',
        },
        technicalError: {
            actionText: 'Erneut versuchen',
            message: 'Wegen eines technischen Fehlers konnte Ihre Anfrage nicht verarbeitet werden. Bitte versuchen Sie es später erneut.',
        },
        invalidForm: {
            message: 'Ihre Eingaben sind leider nicht vollständig oder gültig. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
        },
    },
    summaryStep: {
        insurance: {
            title: 'Gewählter Versicherungsschutz',
            subtitle: 'Eingeschlossene Leistungen (Details und Erläuterungen finden Sie in der Leistungsübersicht)',
        },
        share: {
            label: 'Per E-Mail weiterleiten',
            heading: 'Weiterleiten, später bearbeiten oder ausdrucken',
            send: {
                label: 'Senden',
            },
            subtitle: `Sie können diese Zusammenfassung per E-Mail versenden.<br>Ihre Eingaben bleiben dabei gespeichert und können zu einem später Zeitpunkt ergänzt oder geändert werden.<br>Zusätzlich ist es ebenfalls möglich die Zusammenfassung auszudrucken.`,
            toast: {
                success: 'E-Mail mit dem Link wurde erfolgreich versendet.',
                failed: 'Leider konnte die E-Mail nicht versendet werden!',
            },
        },
        contact: {
            phone: {
                label: 'Telefon',
            },
            mail: {
                label: 'Bestätigungs-E-Mail',
            },
            title: 'Kontaktangaben zum Versicherungsnehmer',
        },
        construction: {
            title: 'Bauvorhaben',
            sum: {
                label: 'Summe',
            },
            duration: {
                label: 'Bauzeit',
            },
        },
        title: 'Zusammenfassung',
        advisor: {
            title: 'Vermittlerangaben',
            mail: {
                label: 'E-Mail des Vermittlers',
            },
        },
        risks: {
            title: 'Merkmale',
        },
        print: {
            title: 'Bauversicherung',
            label: 'Zusammenfassung drucken',
        },
        submit: {
            hint: 'Ihr Versicherungsschutz beginnt ab dem online erfassten Datum Ihres Baubeginns.',
            label: 'Jetzt kaufen',
        },
        edit: {
            toast: {
                message: 'Ihre Prämie wurde neu berechnet!',
            },
        },
        avb: {
            label: '<ul style="list-style: disc;"> <li> Ich bestätige, die <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/vertragsbedingungen/156_1009_d_2021.pdf"  target="_blank">Produktinformationen</a> und die <a href="https://www.baloise.ch/de/ueber-uns/informationen/datenschutz.html" target="_blank">Datenschutzinformation für   Versicherungsverträge</a> gelesen zuhaben und akzeptiere die <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/vertragsbedingungen/156_1009_d_2021.pdf " target="_blank">allgemeinen Vertragsbedingungen</a>  und ermächtige Baloise zur <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Vollmacht-zur-Einholung-von-Drittauskuenften.pdf" target="_blank">Einholung von Drittauskünften.</a>  </li> <li>Ich bestätige, alle Fragen wahrheitsgetreu beantwortet zu haben.</li>  </ul>',
            label_fl: '<ul style="list-style: disc;"> <li> Ich bestätige, die <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/vertragsbedingungen/156_1009_d_2021.pdf">Produktinformationen</a> und die <a href="https://www.baloise.ch/de/ueber-uns/informationen/datenschutz.html" target="_blank">Datenschutzinformation für  Versicherungsverträge</a> gelesen zuhaben und akzeptiere die <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/vertragsbedingungen/156_1009_d_2021.pdf ">allgemeinen Vertragsbedingungen</a>  und ermächtige Baloise zur <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Vollmacht-zur-Einholung-von-Drittauskuenften.pdf" target="_blank">Einholung von Drittauskünften.</a>  </li> <li>Ich bestätige, alle Fragen wahrheitsgetreu beantwortet zu haben.</li> <li>Ich entbinde Baloise vom <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Liechtensteinisches-Geschaeftsgeheimnis.pdf" target="_blank">liechtensteinischen Geschäftsgeheimnis.</a></li> <li>Ich stimme den <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/cyber/000_1362_d.pdf" target="_blank">zusätzlichen Bestimmungen</a> für Verträge nach liechtensteinischem Recht zu und  bestätige, das <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/IPID/156_1025_d.pdf" target="_blank">Informationsblatt zu Versicherungsprodukten (IPID)</a> zur Kenntnis genommen zu  haben.</li> </ul>',
        },
        dp: {
            text: 'Mit Ihrer Datenübermittlung willigen Sie zur Bearbeitung Ihrer Anfrage ein. Sie haben das Recht, diese Einwilligung jederzeit zu widerrufen. Weitere Informationen zu unseren Datenbearbeitungen finden Sie in unserer <a href="https://www.baloise.ch/de/ueber-uns/informationen/datenschutz.html" target="_blank">Datenschutzinformation</a>.',
        },
    },
    matrixStep: {
        liability: {
            personAndPropertyDamage: {
                label: 'Höchstleistung (Einmalgarantie für die gesamte Vertragsdauer)',
            },
            label: 'Bauherren-Haftpflicht',
            doubleGuaranty: {
                label: 'Zweifachgarantie (die Versicherungssumme steht zweimal zur Verfügung)',
            },
            legalProtectionAndFinancialLosses: {
                label: 'Für reine Vermögensschäden und für Rechtsschutz im Strafverfahren je',
            },
        },
        construction: {
            earthquake: {
                label: 'Erdbeben und vulkanische Eruptionen',
            },
            base: {
                tooltip: 'Die Grunddeckung umfasst während der Bauzeit unvorhergesehene Sachschäden am entstehenden, noch nicht fertig gestellten, Bauwerk. Diebstahl von montierten oder eingebauten Sachen.',
                label: 'Grunddeckung',
            },
            addition: {
                one: {
                    label: 'Für bewegte Sachen, für Experten- und Schadensuchkosten, für Gebäudewasserschäden je',
                },
                label: 'Zusatzdeckung',
                two: {
                    label: 'Für Kratzer auf Verglasungen, für Mehrkosten bei Überzeit und Luftfrachten, für Bauzeitverzögerung und Unterbrechung je',
                },
                tooltip: 'Die Zusatzdeckung umfasst unter anderem Gerüst-, Spriess- und weiteres Material, Baugrube und Bodenmassen, Bestehende Bauten, Fahrhabe, Baugeräte, Werkzeuge, Baumaschinen und Ausrüstung.',
                three: {
                    label: 'Einbruchdiebstahl von Sachen, die nicht mit dem Bauwerk verbunden sind',
                },
            },
            label: 'Bauwesen',
        },
        quote: {
            label: 'Einmalige Prämie in CHF',
            stampDuty: {
                label: 'Inkl. Stempelsteuer',
            },
        },
        details: {
            link: 'https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/factsheets/Factsheet_Bauversicherung.pdf',
            label: 'Diese Darstellung ist lediglich eine Zusammenfassung. Sie finden sämtliche Details und Erläuterungen in der <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/factsheets/Factsheet_Bauversicherung.pdf" target="_blank">Leistungsübersicht</a>.',
        },
        deductible: {
            hint: 'für Bauwesen und Bauherren-Haftpflicht',
            label: 'Selbstbehalt',
        },
        additionalLimit: {
            hint: 'für Bauwesen und Bauherren-Haftpflicht',
            label: 'Zweifachgarantie',
            singleGuarantee: '-',
            doubleGuarantee: 'Versichert',
        },
        title: 'Wählen Sie den optimalen Versicherungsschutz aus',
    },
    typeStep: {
        constructionType: {
            apartmentHouse: {
                label: 'Mehrfamilienhaus',
            },
            altLink: {
                text: 'Finden Sie den gewünschten Bautyp nicht,',
                alt: 'dann geht es hier weiter.',
                url: 'https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html',
            },
            industrialBuilding: {
                label: 'Gewerbegebäude',
            },
            commerceAndLiving: {
                label: 'Wohn- und Gewerbegebäude',
            },
            detachedHouse: {
                label: 'Einfamilienhaus',
            },
            title: 'Wählen Sie bitte Ihren Bautyp',
            validation: {
                message: 'Bitte wählen Sie Ihren Bautyp aus.',
            },
        },
        constructionKind: {
            renovation: {
                tooltip: 'Wird ein Gebäude instandgesetzt, ohne Tragelemente zu verändern (z.B. Abbruch einer tragenden Wand) oder Arbeiten am Dach vorzunehmen, wählen Sie bitte Renovation.',
                label: 'Umbau/Renovation',
            },
            newBuilding: {
                tooltip: 'Wird ein Gebäude neu erstellt, an ein bestehendes Gebäude angebaut oder ein Gebäude umgebaut, wählen Sie bitte Neu-/An-/Umbau.',
                label: 'Neubau/Anbau',
            },
            title: 'Wählen Sie bitte Ihr Bauvorhaben',
        },
    },
    riskStep: {
        supportStructureChanged: {
            tooltip: 'Wenn Sie mit Nein antworten, gehen wir davon aus, dass es sich um eine Renovation handelt.',
            label: 'Werden tragende Bauteile (z.B. Wände, Decken, Balkone) verändert oder das Dach bearbeitet?',
        },
        underpinning: {
            tooltip: 'Unterfangen/Unterfahren von fremden Bauteilen/Werken (z.B. Gebäude, Stützmauern, Kanäle, Bahnanlagen)',
            label: 'Werden fremde Gebäudeteile/Werke unterfangen bzw. unterfahren?',
        },
        groundwater: {
            label: 'Wird der Grundwasserspiegel abgesenkt?',
            tooltip: 'Absenkung des Grundwasserspiegels innerhalb einer geschlossenen Baugrubenumschliessung oder ausserhalb der Baugrube (eine offene Wasserhaltung gilt nicht als Grundwasserabsenkung)',
        },
        dangerZone: {
            label: 'Befindet sich das Bauvorhaben in einer Gefahrenzone mit mittlerer oder erheblicher Gefährdung durch Hochwasser, Rutschung, Felssturz, Steinschlag, Lawinen oder liegt eine Gefährdung durch Oberflächenabfluss (Wassertiefe ≥25 cm) vor?',
            warning: 'Weil Ihr Bauvorhaben sich in einer Gefahrenzone befindet, können wir die Prämie leider nicht online berechnen. Gerne bieten wir Ihnen trotzdem eine Offerte an. Bitte kontaktieren Sie <a target="_blank" href="https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html"> uns</a>.',
            tooltip: 'Für die Beurteilung massgebend sind die Gefahrenkarten der Kantone, des Fürstentums Liechtenstein, der Vereinigung kantonaler Gebäudeversicherungen (VKG) sowie des Schweizerischen  Versicherungsverbandes (SVV). Wurden Gefahren im geologischen Gutachten anders bewertet, so sind diese Bewertungen massgebend.',
        },
        ram: {
            label: 'Werden Pfähle, Spundwände oder Stahlträger in den Boden gerammt, vibriert oder gepresst?',
        },
        rock: {
            label: 'Wird Fels abgebaut (Sprengen/Abbauhammer/Meisseln)?',

        },
        newConstruction: {
            label: 'Wird ein neues Gebäude oder ein Anbau erstellt?',
        },
        title: 'Einige Fragen zu Ihrem Bauvorhaben',
    },
    success: {
        title: 'Herzlichen Dank!',
        lead: 'Wir haben Ihre Daten erhalten.<br>In Kürze erhalten Sie Ihre Vertragsunterlagen.<br>Haben Sie Fragen? Kontaktieren Sie uns unter <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
    },
    contactStep: {
        birthdate : {
            label: 'Geburtsdatum',
        },
        street: {
            validation: {
                message: 'Bitte geben Sie eine gültige Strasse ein.',
            },
            placeholder: 'Strasse und Hausnummer',
        },
        title: 'Fast geschafft!',
        lastName: {
            placeholder: 'Nachname',
            validation: {
                message: 'Bitte geben Sie einen gültigen Nachnamen ein.',
            },
        },
        languageOfCorrespondence: {
            de: 'Deutsch',
            label: 'Korrespondenzsprache',
            fr: 'Französisch',
            it: 'Italienisch',
        },
        postcode: {
            placeholder: 'PLZ',
            validation: {
                message: 'Bitte geben Sie eine gültige Postleitzahl ein.',
            },
        },
        city: {
            validation: {
                message: 'Bitte geben Sie einen gültigen Ort ein.',
            },
            placeholder: 'Ort',
        },
        firstName: {
            placeholder: 'Vorname',
            validation: {
                message: 'Bitte geben Sie einen gültigen Vornamen ein.',
            },
        },
        subtitle: {
            email: 'An wen darf die Bestätigung gesendet werden?',
            contact: 'Kontaktangaben zum Versicherungsnehmer',
        },
        salutation: {
            validation: {
                message: 'Bitte wählen Sie die Anrede aus.',
            },
            female: 'Frau',
            male: 'Herr',
            company: 'Firma',
        },
        phone: {
            validation: {
                message: 'Bitte geben Sie eine gültige Telefonnummer ein.',
            },
            placeholder: 'Telefon',
        },
        advisor: {
            placeholder: 'Falls Sie vermittelt wurden, geben Sie hier bitte den Namen und die Vermittlernummer des Vermittlers (z.B. Architekt, Broker,…) an.',
            label: 'Vermittlerangaben (Optional)',
            contactStep: {},
        },
        advisorMail: {
            placeholder: 'E-Mail des Vermittlers (optional)',
        },
        email: {
            placeholder: 'E-Mail des Versicherungsnehmers',
            validation: {
                message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            },
        },
        companyName: {
            placeholder: 'Firma',
            validation: {
                message: 'Bitte geben Sie einen gültigen Firmennamen ein.',
            },
        },
        next: 'Weiter zur Zusammenfassung',
    },
    whenStep: {
        startDate: {
            title: 'Wann beginnen Sie zu bauen?',
            validation: {
                message: 'Bitte wählen Sie ein gültiges Datum aus.',
            },
            tooltip: 'Der Versicherungsschutz beginnt frühestens mit dem Vertragsabschluss.',
            placeholder: 'Baubeginn',
        },
        completionDate: {
            validation: {
                message: 'Bitte wählen Sie den Zeitraum aus.',
            },
            title: 'Bis wann bauen Sie?',
            year: 'Jahr',
            placeholder: 'Bauende',
            upTo: 'Bis zu',
            tooltip: 'Sollte Ihr Bauprojekt länger als 3 Jahre dauern, <a target="_blank" href="https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html"> dann geht es hier weiter.</a>',
            years: 'Jahre',
        },
        title: 'Bauzeit',
    },
    whereStep: {
        postcode: {
            placeholder: 'PLZ',
            label: '',
            validation: {
                message: 'Bitte geben Sie eine gültige Postleitzahl ein.',
            },
        },
        street: {
            label: '',
            validation: {
                message: 'Bitte geben Sie eine gültige Adresse ein.',
            },
            placeholder: 'Strasse und Hausnummer oder Parzellennummer',
        },
        city: {
            validation: {
                message: 'Bitte geben Sie einen gültigen Ort ein.',
            },
            placeholder: 'Ort',
            dropDownLabel: 'Bitte auswählen',
            label: '',
        },
        title: 'Wo bauen Sie?',
    },
    fail: {
        lead: 'Bitte versuchen Sie es später erneut oder kontaktieren Sie uns unter <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        title: 'Leider ist ein Fehler aufgetreten.',
    },
    sumStep: {
        sum: {
            info: {
                text1: 'Für die Ermittlung der Bausumme addieren Sie die Positionen 1-4 des Baukostenplans (inkl. Mehrwertsteuer, Honorare und Eigenleistungen des Bauherrn).',
                text2: 'Nicht zur Bausumme zählen Kosten für Vorstudien, Wettbewerbe, Grundstückserwerb, Erschliessung, Finanzierung, Gebühren.',
                text3: 'Falls Ihre Bausumme höher als CHF 10\'000\'000 ist, <a target="_blank" href="https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html"> dann geht es hier weiter.</a>',
                title: 'Wie berechne ich die Bausumme?',
            },
            label: 'CHF',
            placeholder: '500\'000',
            validation: {
                message: 'Die Bausumme muss mindestens CHF 10\'000 und darf höchstens CHF 10 Mio sein.',
            },
        },
        title: 'Wie hoch ist die Bausumme?',
    },
    app: {
        title: 'Baloise Bauversicherung',
    },
    overview: {
        print: {
            label: 'Angebot drucken',
        },
        hint: {
            text: 'Haben Sie Fragen? Kontaktieren Sie uns unter <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        },
        title: 'Ihr Angebot im Detail',
    },
    easteregg: {
        message: 'Ein fröhliches Produkt des Bets-Teams',
    },
};
